import toast from "react-hot-toast";
import { FormValuesVehicleUpdate } from "./validationShemaUpdate";
import i18n from "../../../../i18n/i18n";

export const checkValues = (values: FormValuesVehicleUpdate) => {
  if (
    values.brand === null ||
    values.modele === null ||
    !values.vin?.trim() ||
    !values.immatriculation?.trim() ||
    !values.fiscalPower?.trim() ||
    !values.gearBox?.trim() ||
    !values.energy?.trim() ||
    !values.releaseDate ||
    !values.status?.trim()
  ) {
    toast.error(i18n.t("required.checkFields", "Please fill in all required fields"));
    return false;
  }
  return true;
};
